import { clsx } from 'clsx/lite'
import React from 'react'

type DividerProps = {
  className?: string
}

export const Divider: React.FC<DividerProps> = ({ className }) => (
  <hr className={clsx('h-[1px] border-none bg-grey-100', className)} />
)
